import classNames from 'classnames';
import './ProductCard.css';
import { Product } from "@/common/constants/interfaces";

interface ProductCardProps {
    product: Product;
    selected: boolean;
    onSelect: (product: Product) => void;
}

function ProductCard(props: ProductCardProps) {
    const { product, selected, onSelect } = props;
    const { name, price, description, } = product;

    const cs = classNames('product-card', {
        'product-card-selected': selected
    })

    const handleClick = () => {
        onSelect(product);
    }

    return (
        <div className={cs} onClick={handleClick}>
            <div className="product-name">{name}</div>
            <div className="product-price">￥{price}</div>
            <div className="product-description">{description}</div>
        </div>
    )
}

export default ProductCard;